// WhatsApp API Configuration
// These credentials should ideally be stored in environment variables
const WhatsAppConfig = {
  baseUrl: "https://deropo.co.in/api/send",
  instanceId: "69B4E54B30DFF",
  accessToken: "69576574f01a0",
};

export default WhatsAppConfig;
